module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_maedori-ab2a6f0bfa6bcd491e0865bf2507ce3a.webp";